// import VueLogger from 'vuejs-logger';

// export {
// 	getUserCurrentAddress
// };

// Location Picker Function
import axios from "axios";

export function getUserCurrentAddress() {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(success, error);
  }
  function success(position) {
    return {
      lat: position.coords.latitude,
      long: position.coords.longitude,
    };
  }
  function error() {
    return {
      lat: 0,
      long: 0,
    };
  }
}

export function see_location(map_location, $this) {
  var street = "";
  var country = "";
  var city = "";
  var postal_code = "";
  var state = "";
  var company_address = {};
  var map_address = "https://maps.googleapis.com/maps/api/geocode/json?latlng=" + map_location.lat + "," + map_location.lng + "&key=AIzaSyC98nQcjsYa0U6aGqXQhOkpbYftkRFcE6U"
  axios
    .get(
      map_address
    )
    .then(res => {
      var location_address = res.data.results[0]["address_components"];
      location_address.forEach(element => {
        if (element["types"].includes("route")) {
          street = element["long_name"] + " ";
        }
        if (element["types"].includes("sublocality_level_2")) {
          street = street.concat(element["long_name"], " ");
        }
        if (
          element["types"].includes("sublocality_level_1") &&
          !element["types"].includes("sublocality_level_2")
        ) {
          street = street.concat(element["long_name"], " ");
        }
        if (element["types"].includes("country")) {
          country = element["long_name"];
        }
        if (
          element["types"].includes("administrative_area_level_2") ||
          element["types"].includes("locality")
        ) {
          city = element["long_name"];
        }
        if (element["types"].includes("postal_code")) {
          postal_code = element["long_name"];
        }
        if (element["types"].includes("administrative_area_level_1")) {
          state = element["long_name"];
        }
      });
      company_address.street = street;
      company_address.country = country;
      company_address.city = city;
      company_address.zip_code = postal_code;
      company_address.state = state;
      company_address.latitude = map_location.lat;
      company_address.longitude = map_location.lng;
      $this.$emit("updateAddress", {company_address:company_address,map_address:map_address});
    });
}



// WEBPACK FOOTER //
// ./src/components/mixins/location.js